import React from 'react'

interface ActivityFiltersProps {
  [key: string]: any
}

export const ActivityFilters: React.FC<ActivityFiltersProps> = (props) => {
  return (
    <div className="p-4 bg-gray-800 rounded-lg">
      <p className="text-gray-400">ActivityFilters Component - Coming Soon</p>
    </div>
  )
}
